import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import { useNft } from '../contexts/NftContext.js'; // Adjust the path as necessary
import useSolanaWeb3 from '../hooks/useSolanaWeb3';
import useNftDetails from '../hooks/useNftDetails';
import { useSelector } from 'react-redux';
import { selectAppNft } from '../store/appSlice.js';

function CenterContent({setAntInfo, setImageUri, setAntLevel, setRemainPotions, changeActiveComponent}) {
  const { wallet } = useSolanaWeb3();
  const { updateActiveNft } = useNft();
  const [activeNft, setActiveNft] = useState(null);
  const [activeImage, setActiveImage] = useState(null);
  const { level, remainPotions } = useNftDetails(activeNft, "leveling");

  const { nfts, loading } = useSelector(selectAppNft)

  const sliderSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: current => {
      const newActiveNftTokenAddress = nfts[current].mint;
      setActiveImage(nfts[current].metadata.image);
      setActiveNft(newActiveNftTokenAddress);
    },
  };

  useEffect(()=>{
    updateActiveNft({
      activeTokenAddress: activeNft,
      level,
      remainPotions,
    });
  },[activeNft, level, remainPotions])

  useEffect(()=>{
      const newActiveNftTokenAddress = nfts[0]?.mint;
      setActiveImage(nfts[0]?.metadata.image);
      setActiveNft(newActiveNftTokenAddress);
  },[nfts])

  useEffect(()=>{
    if(activeNft && activeImage){
      setAntInfo && setAntInfo(activeNft);
      setImageUri && setImageUri(activeImage);
    }
  },[activeNft,activeImage])


  return (
    <div className="center-content">
      <div className='w-[calc(41*var(--dynamic-vunit))]'>
        {loading ? (
          <div>Loading your ants...</div> // Display loading message
        ) : nfts && nfts.length > 0 ? (
          <Slider {...sliderSettings}>
            {nfts.map((ant) => (
              <div key={ant.mint} className='flex flex-col items-center'>
                <img src={ant.metadata.image} alt='' className='w-[calc(41*var(--dynamic-vunit))]' />
              </div>
            ))}
          </Slider>
        ) : (
          <div><button onClick={() => changeActiveComponent('shop')} className="buy-more-ants-button">BUY ANT</button></div> // Display this message if no NFTs are found
        )}
      </div>
    </div>
  );
}

export default CenterContent;